<template>
  <div class="content--sinoreg">
    <div class="CategoriasEAtos">
      <div class="CategoriasEAtos_header">
        Categorias e Tipo de Ato
      </div>
      <div class="CategoriasEAtos_search m-2">
        <div class="row align-items-end justify-content-between">
          <div class="col-8 d-inline-flex p-0">
            <div class="col-4">
              <label for="tipo">Tipo de lançamento</label>
              <div class="row">
                <div class="col-6">
                  <b-form-radio v-model="localData.tipo"
                                name="some-radios"
                                value="DESPESA"
                                @change="changeTipo">
                    Despesa
                  </b-form-radio>
                </div>
                <div class="col-6 pl-4">
                  <b-form-radio v-model="localData.tipo"
                                name="some-radios"
                                value="RECEITA"
                                @change="changeTipo">
                    Receita
                  </b-form-radio>
                </div>
              </div>
            </div>
            <div class="col-8">
              <label for="categoria">Buscar categoria</label>
              <input id="categoria"
                     v-model="localData.nome"
                     type="text"
                     class="form-control form-control-sm"
                     @change="changeName"
                     @keydown.enter="changeName">
            </div>
          </div>

          <button class="btn btn-sm btn-primary mr-2"
                  @click="showForm = true">
            <icon-svg icon="add"
                      class="icon-add icon--sm" />
            Adicionar categoria ou tipo de ato
          </button>
        </div>
      </div>
      <div v-if="categorias.length"
           class="CategoriasEAtos_results mt-3">
        <ListagemCategorias :prop-categorias="categorias"
                            @excluirCategoria="excluirCategoria"
                            @editarCategoria="editarCategoria"
                            @atualizarCategoria="atualizarCategoria" />
        <Pagination
          class="mt-4"
          :per-page="perPage"
          :page="page"
          :last-page="lastPage"
          :select-page="true"
          @onPreviousPage="[page = page - 1, getCategorias()]"
          @onNextPage="[page = page + 1, getCategorias()]"
          @onSetPage="page => goPage(page)" />
      </div>
      <div v-else
           class="row justify-content-center my-5">
        <b>Nenhum resultado encontrado</b>
      </div>
    </div>
    <FormCategoria v-if="showForm"
                   :prop-categoria="categoria"
                   @cadastrar="cadastrarCategoria"
                   @editar="atualizarCategoria"
                   @hide="hideForm()" />
  </div>
</template>

<script>
  //Components
  import Pagination from "@/components/SofiaRei/Pagination"
  import FormCategoria  from "@/components/SofiaRei/Categorias/FormCategoria"
  import ListagemCategorias  from "@/components/SofiaRei/Categorias/ListagemCategorias"

  //Service
  import CategoriasService from "@/services/CategoriaService"

  export default {
    name: 'CategoriasEAtos',
    components: {
      Pagination,
      FormCategoria,
      ListagemCategorias
    },
    data () {
      return {
        showForm: false,
        localData: {
          tipo: null,
          nome: null
        },
        categoria: null,
        perPage: 20,
        page: 1,
        lastPage: 1,
        categorias: [],
        isBusy: false,
        search: null
      }
    },
    mounted () {
      this.getCategorias()
    },
    methods: {
      async getCategorias () {
        try {
          loader({active: true, text: 'Buscando categorias...'})

          const res = await CategoriasService.getCategorias({
            ...this.localData,
            page: this.page,
            perPage: this.perPage,
            group_by_nome: false
          })

          if (res && res.data.length || this.page === 1) {
            this.categorias = res.data
            this.page = res.page
            this.perPage = res.perPage
            this.lastPage = res.lastPage
          } else if (this.page > 1) {
            this.page = this.page - 1

            this.getCategorias()
          }

        } catch (error) {
          const message = getErrors(error)

          displayMessage('error', 'Erro!', message.message)
        } finally {
          loader({active: false, text: null})
        }
      },
      editarCategoria (categoria) {
        this.categoria = {...categoria},
        this.showForm = true
      },
      async cadastrarCategoria (categoria) {
        try {
          loader({active: true, text: 'Cadastrando categoria...'})

          const res = await CategoriasService.cadastrarCategoria(categoria)

          if (res) {
            displayMessage('success', 'Categoria cadastrada com sucesso!').then(() => {
              this.showForm = false
              this.getCategorias()
            })
          }

        } catch (error) {
          const message = getErrors(error)

          displayMessage('error', 'Erro!', message.message)
        } finally {
          loader({active: false, text: null})
        }
      },
      async atualizarCategoria (categoria) {
        if (!Object.values(categoria).length) {
          displayMessage('success', 'Nada para atualizar!')
          this.hideForm()
          return
        }

        try {
          loader({active: true, text: 'Atualizando categoria...'})

          const res = await CategoriasService.atualizarCategoria(categoria, categoria.categoria_id)

          if (res) {
            displayMessage('success', 'Categoria atualizada com sucesso!').then(() => {
              this.showForm = false
              this.getCategorias()
            })
          }

        } catch (error) {
          const message = getErrors(error)

          displayMessage('error', 'Erro!', message.message)
        } finally {
          loader({active: false, text: null})
        }
      },
      async excluirCategoria (categoria) {
        try {
          loader({active: true, text: 'Excluindo categoria...'})

          const res = await CategoriasService.excluirCategoria(categoria.categoria_id)

          if (res) {
            displayMessage('success', 'Categoria excluida com sucesso!').then(() => {
              this.showForm = false
              this.getCategorias()
            })
          }

        } catch (error) {
          const message = getErrors(error)

          if (typeof message.message === 'string' && message.message.match('Cannot delete or update a parent row: a foreign key constraint fails')) {
            return displayMessage('error','Erro!',  'Não é possível excluir uma categoria vinculada a um lançamento.')
          }

          displayMessage('error', 'Erro!', message.message)
        } finally {
          loader({active: false, text: null})
        }
      },
      hideForm () {
        this.categoria = null
        this.showForm = false
      },
      goPage (page) {
        this.page = page
        this.getCategorias()
      },
      changeTipo (tipo) {
        this.localData.tipo = tipo
        this.page = 1

        this.getCategorias()
      },
      changeName (event) {
        const nome = event.target.value

        this.localData.nome = nome

        this.getCategorias()
      }
    }
  }
</script>

<style lang="scss">
  .CategoriasEAtos {
    &_header {
      background: #074f7f;
      color: #fff;
      padding: 10px;
      font-size: 20px;
      font-weight: bold;
    }
  }

  .CategoriasEAtos label {
    font-size: 15px;
    font-weight: 500;
    color: #373a3c;
  }

  .icon-add {
    fill: #fff !important;
    width: 18px;
    height: 18px;
  }
</style>
